import type { Organization } from '@platform/types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api-client';
import { useAuthStore } from '@/store/auth-store';

/**
 * Active organization (settings incl. displayCurrency). Only fetches when a
 * user is signed in — marketing pages get `undefined` and fall back to
 * browser-locale currency detection.
 */
export function useOrganization() {
  const user = useAuthStore((s) => s.user);
  return useQuery({
    queryKey: ['organization', user?.activeOrganizationId],
    queryFn: () => apiFetch<Organization>('/organizations/current'),
    enabled: Boolean(user),
    staleTime: 60_000,
  });
}
